import { Bone } from '../../../../common/components/TabSkeleton'

const SKELETON_BANKS = 1
const SKELETON_ACCOUNT_ROWS = 7

export const BankPaymentCodeSkeleton = () => (
  <div
    className='placeholder-glow d-flex flex-column gap-8'
    data-testid='bank-payment-code-skeleton'
  >
    <div className='card p-5 d-flex flex-row justify-content-between align-items-end gap-5'>
      <div className='w-50'>
        <Bone h={28} w='320px' mb={10} />
        <Bone h={16} w='90%' />
      </div>
      <Bone h={42} w='250px' />
    </div>
    {Array.from({ length: SKELETON_BANKS }, (_, bank) => (
      <div key={bank} className='card p-10'>
        <div className='d-flex justify-content-between'>
          <Bone h={22} w='300px' />
          <Bone h={32} w='200px' />
        </div>
        <div className='mt-5'>
          <Bone h={20} w='260px' />
        </div>
        <div className='separator my-6' />
        <Bone h={16} w='100%' mb={18} />
        {Array.from({ length: SKELETON_ACCOUNT_ROWS }, (_, row) => (
          <Bone key={row} h={32} mb={12} />
        ))}
      </div>
    ))}
  </div>
)
